import {
  Button,
  Field,
  Picker,
  ActionSheet,
  RadioGroup,
  Radio,
  Cell,
  Switch,
  CountDown,
  Dialog,
  Overlay,
  Checkbox,
  CheckboxGroup,
  NavBar,
  Icon,
  Popup,
  Popover,
  Toast,
  Uploader,
  Cascader,
  Loading,
} from 'vant'

const components = [
  Button,
  Field,
  Picker,
  ActionSheet,
  RadioGroup,
  Radio,
  Cell,
  Switch,
  CountDown,
  Dialog,
  Overlay,
  Checkbox,
  CheckboxGroup,
  NavBar,
  Icon,
  Popup,
  Popover,
  Toast,
  Loading,
  Uploader,
  Cascader,
]

export function requireVant(obj: any) {
  components.forEach(item => {
    obj.use(item)
  })
}
